<template>
  <div class="inquire">
    <div class="top flexsb">
      <div class="flex">
        <div class="left flexc">
          <div class="h30 mb20 w200 flexend" style="text-align:right;">參照編號</div>
          <div class="h30 mb20 w200 flexend">總數</div>
          <div class="h30 mb20 w200 flexend">卡號</div>
        </div>
        <div class="right flexc">
          <div class="h30 mb20">{{order_no}}</div>
          <div class="h30 mb20">
            <span class="p-FA800A p-fw">{{totalLength}}</span>
            <span style="margin-left: 6px;">張</span>
          </div>
          <el-input
            v-model="account"
            @change="changeCardList"
            clearable
            class="mb20"
            style="width:300px;"
          ></el-input>
          <el-button
            type="primary"
            class="p-fw"
            style="width:100px; margin-top: 20px;"
            @click="inquire"
          >查看</el-button>
        </div>
      </div>
      <div class="img-box flexc flexa">
        <img src="@/assets/qr_code.png" width="132" height="132" alt class="mb20" />
        <span class="p-999 p-f12">可掃碼下載全球付APP查看更多管理</span>
      </div>
    </div>
    <div class="bottom">
      <el-table
        :data="cardList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
        style="width: 100%"
      >
        <el-table-column prop="card_no" label="卡號" width="200"></el-table-column>
        <el-table-column prop="valid_date" label="有效期" width="100"></el-table-column>
        <el-table-column prop="cvc2" label="CVC2" width="100"></el-table-column>
        <el-table-column prop="statusInWords" label="狀態" width="100"></el-table-column>
        <el-table-column prop="currency" label="幣種" width="100"></el-table-column>
        <el-table-column prop="balance" label="余額" width="120"></el-table-column>
        <el-table-column prop="invalid_date" label="失效期"></el-table-column>
        <el-table-column
          prop="activate_code"
          label="激活碼後6位（登錄APP）"
          width="120"
          v-if="type==='entity'"
          align="center"
        ></el-table-column>
        <el-table-column label="初始密碼（登錄APP）" width="120" v-if="type==='virtual'">
          <template slot-scope="scope">
            <span class="getCode" @click.stop="getCode(scope.row)">獲取密碼</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 30px;" v-if="total>=pagesize">
        <el-pagination
          @current-change="current_change"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//{"errCode":"99999","errMsg":"success","retData":[{"card_no":"5387380460894247","valid_date":"05/24","cvc2":"506 ","status":"00","currency":"CNY","balance":"88800.0","invalid_date":"2020/11/19","activate_code":"197679"},{"card_no":"5387380468082100","valid_date":"11/24","cvc2":"857 ","status":"00","currency":"CNY","balance":"10000.0","invalid_date":"2020/11/19","activate_code":"197539"},{"card_no":"5387380468192933","valid_date":"06/24","cvc2":"272 ","status":"00","currency":"CNY","balance":"131400.0","invalid_date":"2020/11/19","activate_code":"204210"},{"card_no":"5387380469232043","valid_date":"08/24","cvc2":"868 ","status":"00","currency":"CNY","balance":"168800.0","invalid_date":"2020/11/19","activate_code":"204129"},{"card_no":"5387380469842130","valid_date":"05/24","cvc2":"346 ","status":"00","currency":"CNY","balance":"52000.0","invalid_date":"2020/11/19","activate_code":"204061"}]}
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
export default {
  data() {
    return {
      totalLength: 0,
      nowIndex: 1,
      account: "",
      order_no: "",
      card_no: "",
      type: "",
      activateCode: "",
      pagesize: 10,
      currentPage: 1,
      cardList: [],
      cardListBackup: []
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  computed: {
    total() {
      return this.cardList.length;
    }
  },
  methods: {
    current_change(currentPage) {
      this.currentPage = currentPage;
    },
    async getCode({ card_no }) {
      let params = {
        order_no: this.order_no,
        card_no
      };
      let res = await aPost2(api.getCardPsw, params);
      if (res.data.errCode === "99999") {
        this.$message({
          message: `初始密碼已成功發送至預留的郵箱${res.data.retData}`,
          type: "success"
        });
      } else {
        this.$message({
          message: `${res.data.errMsg}`,
          type: "error"
        });
      }
    },
    async getCardList() {
      let params = {
        order_no: this.order_no,
        card_no: this.card_no
      };
      let res = await aPost2(api.queryCard, params);
      if (res.data.errCode === "99999") {
        if (res.data.retData.length > 0) {
          let data = res.data.retData;
          data.forEach(e => {
            e.balance = (e.balance / 100).toFixed(1);
            switch (e.status) {
              case "00":
                e.statusInWords = "正常";
                break;
              case "01":
                e.statusInWords = "未啟用";
              case "03":
                e.statusInWords = "正在制卡";
              case "10":
                e.statusInWords = "暫停";
              case "11":
                e.statusInWords = "鎖卡";
              case "18":
                e.statusInWords = "臨時暫停";
              case "90":
                e.statusInWords = "分配鎖定";
              case "99":
                e.statusInWords = "已註銷";
              default:
                break;
            }
          });
          this.cardList = res.data.retData;
          this.cardListBackup = res.data.retData;
          this.totalLength = this.cardListBackup.length;
        }
      } else {
        this.$message.error(`${res.data.errMsg}`);
      }
    },
    inquire() {
      if (!this.account) {
        this.$message.error(`篩選卡號不能為空`);
        return false;
      }
      let cardList = this.cardList;
      let tempArr = [];
      if (cardList.some(e => e.card_no === this.account)) {
        cardList.forEach(e => {
          if (e.card_no === this.account) {
            this.cardList = [];
            this.cardList.push(e);
            this.total = 1;
            this.currentPage = 1;
          }
        });
      } else {
        this.$message.error(`查無此卡！`);
      }
    },
    async getOrderStatus() {
      let res = await aPost2(api.queryStatus, { order_no: this.order_no });
      if (res.data.errCode === "99999") {
        // this.status = res.data.retData.status;
        this.type = res.data.retData.card_type === "00" ? "entity" : "virtual";
      }
    },
    changeCardList() {
      if (!this.account) {
        this.currentPage = 1;
        this.cardList = this.cardListBackup;
        this.total = this.cardListBackup.length;
      }
    }
  },
  mounted() {
    if (this.$route.params.order_no || sessionStorage.getItem("order_no")) {
      this.order_no =
        this.$route.params.order_no || sessionStorage.getItem("order_no");
      this.getOrderStatus();
      this.getCardList();
    } else {
      this.$router.replace({ name: "auth" });
    }
  }
};
</script>

<style lang="scss" scoped>
.inquire {
  width: 960px;
  margin: 40px auto;
  font-size: 16px;
  .top {
    padding-top: 40px;
    border: 1px solid #ccc;
    border-radius: 4px;
    .left {
      height: 260px;
      padding-right: 40px;
    }
    .right {
      height: 260px;
    }
    .mb20 {
      margin-bottom: 20px;
    }
    .w200 {
      width: 200px;
    }
    .h30 {
      display: flex;
      align-items: center;
      height: 36px;
    }
    /deep/ .el-input__inner {
      height: 36px;
    }
    .img-box {
      margin-right: 100px;
    }
  }
  .bottom {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 2px;
    margin-top: 30px;
    .getCode {
      font-size: 12px;
      border: 1px solid #666;
      padding: 2px 10px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>